module.exports = __webpack_public_path__ + "ingpay.png?f27583b26e81553f81489b9d14d2cc94";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/ingpay.png
// module id = Mjfs
// module chunks = 50